import type { Draft } from '~publish/legacy/composer/composer/entities/Draft'

import type { EditPostInput } from './graphqlTypes'
import type { MapperContext } from './types'
import { mapSharedPostFields } from './mapSharedPostFields'
import { resolveEditScheduling } from './resolveEditScheduling'

// Pure mapper: one legacy per-channel `Draft` (+ context + post id) → one
// `EditPostInput`. Edit stays one call per post.
//
// Scheduling is resolved separately from the shared fields: `mapSharedPostFields`
// always asserts a create-shaped `mode`, but an edit must omit scheduling when the
// user didn't change it so the server preserves the post's placement
// (see `resolveEditScheduling`).
export function mapToEditPostInput(
  draft: Draft,
  ctx: MapperContext,
  postId: string,
): EditPostInput {
  const {
    mode: _mode,
    dueAt: _dueAt,
    ...shared
  } = mapSharedPostFields(draft, ctx)

  return {
    id: postId,
    ...shared,
    ...resolveEditScheduling(ctx),
    // Omitted unless the save carries an approval intent, so a plain save leaves
    // the post's approval state exactly as stored.
    ...(ctx.requestApproval !== undefined
      ? { approvalChange: ctx.requestApproval ? 'request' : 'revert' }
      : {}),
  }
}
